export default {
  title: 'Zmień hasło',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Wprowadź e-mail',
    },
    new_password: {
      label: 'Nowe hasło',
      placeholder: 'Wprowadź hasło',
      requirements: 'Hasło musi zawierać 8 znaków, wielką literę i cyfrę',
    },
    confirm_password: {
      label: 'Potwierdzenie nowego hasła',
      placeholder: 'Potwierdź hasło',
    },
    error_messages: {
      missing_info: 'Brakujące informacje',
    },
  },
  buttons: {
    change_password: 'Zmień hasło',
  },
};
